import { State } from '@user/features/Activity/state'

export const createActivitiesBulkProducer = (state: State): State => ({
  ...state,
})
